import { render, staticRenderFns } from "./RelacaoCancelamentoEntregas.vue?vue&type=template&id=583a7ed0"
import script from "./RelacaoCancelamentoEntregas.vue?vue&type=script&lang=js"
export * from "./RelacaoCancelamentoEntregas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports